import { z } from 'zod'
import { funnelSchema } from './funnel-schema'

const baseLeadMagnetSchema = funnelSchema
  .pick({ phone: true, age: true, first_name: true, last_name: true, email: true, household_income: true })
  .partial({ age: true, household_income: true })
  .extend({
    phone: z.preprocess((val) => (val === '' ? undefined : val), funnelSchema.shape.phone.optional()),
    household_income: z.preprocess(
      (val) => (val === '' ? undefined : val),
      funnelSchema.shape.household_income.optional()
    ),
    first_name: z.preprocess((val) => (val === '' ? undefined : val), funnelSchema.shape.first_name.optional()),
    last_name: z.preprocess((val) => (val === '' ? undefined : val), funnelSchema.shape.last_name.optional()),
    schedule_call_interest: z.boolean().optional(),
    investable_assets_range: funnelSchema.shape.investable_assets_range,
  })

/**
 * Builds a schema that requires fields only when they are present in the
 * rendered fields list — prevents silent pass-through when a field is rendered
 * but the user hasn't filled it in.
 */
export function buildLeadMagnetSchema(renderedFields: string[]) {
  return baseLeadMagnetSchema.superRefine((data, ctx) => {
    if (renderedFields.includes('household_income') && data.household_income == null) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: 'Household income is required',
        path: ['household_income'],
      })
    }
    if (renderedFields.includes('age') && data.age == null) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: 'Age is required',
        path: ['age'],
      })
    }
    if (renderedFields.includes('first_name') && !data.first_name) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: 'First name is required',
        path: ['first_name'],
      })
    }
    if (renderedFields.includes('last_name') && !data.last_name) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: 'Last name is required',
        path: ['last_name'],
      })
    }
  })
}

export const leadMagnetSchema = baseLeadMagnetSchema

export type LeadMagnetSchema = z.infer<typeof baseLeadMagnetSchema>
